import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"],
})
export class ProjectComponent implements OnInit {
  Device;
  DeviceTypeList;
  successfulData;
  ProjectList: any[];
  filter;
  SkypeTypeList: any[];
  CiscoTypeList: any[];
  Countries;
  Project;
  projectMemberAssignments;
  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];
  slotFilter: any = {
    start: "",
    practitionerCodeDisplay: "",
    practitionerName: "",
  };
  public country = "";
  public Type = "";
  public rowsPerPage = 5;
  public LoginEnterpriseID = "";
  public Country = "";
  public DeviceType;
  public Role = "";
  dataLoader: boolean;
  theFile: any;
  addModifyHostNamesForm: FormGroup;

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private fb: FormBuilder,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    this.dataLoader = true;
    this.Project = {
      Country: "",
      ProjectName: "",
      ProjectLead: "",
      Type: "",
      UserId: "",
      WBSEelement: "",
      PhoneNumber: "",
      AuthCode: "",
      GroupMembers: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
    };
    this.projectMemberAssignments = {
      grdfCountries: "",
      grdfProjectName: "",
      grdfProjectLead: "",
      grdfType: "",
      grdfProjectMembers: "",
    };
    this.successfulData = {
      projectMemberAssignments: "",
    };
    this.DeviceTypeList = [
      // { name: 'Skype', },
      { name: "Cisco" },
      { name: "Teams" },
    ];
    this.GetCountryList();
    this.GetDropDownLoad();
    this.AudiLogin();

    this.addModifyHostNamesForm = this.fb.group({
      facility: ["", Validators.required],
      domain: ["", Validators.required],
      device: ["", Validators.required],
      hostName: ["", Validators.required],
      inputFile: "",
    });
  }
  // Method Declaration
  AudiLogin() {
    this.capservice
      .AudiLogin("Profile", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^[\d ()+-]+$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
      this.dataLoader = false;
    });
  }
  DeviceTypeEvent(event: any) {
    //Paginator.page = 0;
    this.ClearDevice();
    this.Device = event.target.value;
    if (
      this.Device == "Skype" ||
      this.Device == "Cisco" ||
      this.Device == "Teams"
    ) {
      $("#AlertForAccess").css("display", "none");
      if (this.Device == "Skype" || this.Device == "Teams") {
        $("#divProjectDetailsCommon").css("display", "block");
        $("#divProjectDetailsSubmit").css("display", "block");
        $("#divProjectDetailsCommonupload").css("display", "block");
        $("#divProjectDetails").css("display", "block");
        $("#ProjectDetailsSkype").css("display", "block");
        $("#ProjectDetailsCisco").css("display", "none");
        $("#uploadhr").css("display", "block");
      } else if (this.Device == "Cisco") {
        $("#divProjectDetailsCommon").css("display", "block");
        $("#divProjectDetailsSubmit").css("display", "block");
        $("#divProjectDetailsCommonupload").css("display", "none");
        $("#divProjectDetails").css("display", "block");
        $("#ProjectDetailsSkype").css("display", "none");
        $("#ProjectDetailsCisco").css("display", "block");
        $("#uploadhr").css("display", "none");
      }
      this.LoadInitData();
    } else {
      $("#AlertForAccess").css("display", "block");
      $("#divProjectDetailsCommon").css("display", "none");
      $("#divProjectDetailsSubmit").css("display", "none");
      $("#divProjectDetailsCommonupload").css("display", "none");
      $("#divProjectDetails").css("display", "none");
      $("#ProjectDetailsSkype").css("display", "none");
      $("#ProjectDetailsCisco").css("display", "none");
    }
  }
  LoadInitData() {
    this.dataLoader = true;
    this.capservice
      .GetVoiceAdminDetails(this.Device, "Project", this.country)
      .subscribe((data) => {
        if (data.length >= 0) {
          //this.dataLoader = true;
          this.successfulData = {
            projectMemberAssignments: data,
            selected: {},
          };
          this.allItems = data;
          // initialize to page 1
          this.setPage(1);
          this.dataLoader = false;
        }
      });
    this.capservice
      .GetVoiceAdminDetails(this.Device, "ProjectDropdown", this.country)
      .subscribe((data) => {
        if (data.length >= 0) {
          this.ProjectList = data;
          this.dataLoader = false;
        }
      });
  }
  GetDropDownLoad() {
    this.capservice
      .DropdownValues("SkypeTypeList", "Skype")
      .subscribe((data) => {
        this.SkypeTypeList = data;
      });
    this.capservice
      .DropdownValues("CiscoTypeList", "Cisco")
      .subscribe((data) => {
        this.CiscoTypeList = data;
      });
  }
  ProjectMember(type) {
    if (type == "Edit") {
      var i = $("#grdProjectMembers").val();
    } else {
      var i = $("#grdfProjectMembers").val();
    }
    var keywordsArr = i.split(',')
    if (keywordsArr.length > 5) {
      alert("Only 5 or less Enterprise/Group Id's are allowed");
    }
  }
  ShowData() {
    //Paginator.page = 0;
    if ($("#dlstProjectName").val() == "" && $("#dlstCountry").val() == "") {
      $("#divProjectDetails").css("display", "none");
      alert("Please select value to search");
    }
    else {
      var Country = '';
      var ProjectName = $('#dlstProjectName').val() == '' ? 'N' : $('#dlstProjectName').val()
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
      }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();
      }
      this.capservice.SearchDetailsNew(ProjectName, Country, 'N', this.Device, "Project").subscribe(data => {
          if (data.length > 0) {
            this.successfulData = {
              projectMemberAssignments: data,
              selected: {},
            };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            $("#divProjectDetails").css("display", "block");
          } else {
            $("#divProjectDetails").css("display", "none");
            this.LoadInitData();
            alert("No Records Found");
          }
        });
    }
  }
  ExportToBulkExcel() {
      var Country = '';
      var ReportName = 'Project.xlsx';

      var ProjectName = $('#dlstProjectName').val() == '' ? 'N' : $('#dlstProjectName').val()
      if (this.Role != 'Global Admin') {
        Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
    }
      else {
        Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();
      }      
        this.capservice.SearchDetailsBulkDownload(ProjectName, Country, 'N', this.Device, "Project").subscribe((data:Blob)=>{
          this.dataLoader = true;
          if (data.size > 0) {
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob){ // for IE
            (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
        }
          else{
            var link = document.createElement('a');
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  ProjectAdd() {
    var message = ''; var val = '';
    if (this.Device == 'Skype' || this.Device == 'Teams') {

      if ($('#grdfCountries').val() == '') {
        message = "Please Select Country";
      }
      if ($("#grdfProjectName").val() == "") {
        message = message + "\n" + "Please Enter Project Name";
      }
      if ($("#grdfProjectLead").val() == "") {
        message = message + "\n" + "Please Enter Project Lead";
      }
      if ($("#grdfType").val() == "") {
        message = message + "\n" + "Please Select Type";
      }
      if ($("#grdfProjectMembers").val() == "") {
        message = message + "\n" + "Please Enter Project Members";
      }
    } else {
      if ($("#grdCCountries").val() == "") {
        message = "Please Select Country";
      }
      if ($("#grdCProjectName").val() == "") {
        message = message + "\n" + "Please Enter Project Name";
      }
      if ($("#grdCProjectLead").val() == "") {
        message = message + "\n" + "Please Enter Project Lead";
      }
      if ($("#grdCType").val() == "") {
        message = message + "\n" + "Please Select Type";
      }
      if ($("#grdfUserID").val() == "") {
        message = message + "\n" + "Please Enter User ID";
      }
      if ($("#grdCType").val() == "Chargeback") {
        if ($("#grdfWBSE").val() == "") {
          message = message + "\n" + "Please Enter WBSE";
        }
      }
      if ($("#grdfAuthCode").val() == "") {
        message = message + "\n" + "Please Enter AuthCode";
      }
      if ($("#grdfPhoneNumber").val() == "") {
        message = message + "\n" + "Please Enter Phone Number";
      }
    }
    if (message != "") {
      alert(message);
      //this.clear();
    }
    else {
      var i = $('#grdfProjectMembers').val();
      var keywordsArr = i.split(',')
      if (keywordsArr.length > 5) {
        alert("Only 5 or less Enterprise/Group Id's are allowed");
      } else {
        // this.Project.Country = (MYCASService.encryptedlogin(this.Project.Country)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.ProjectName = (MYCASService.encryptedlogin(this.Project.ProjectName)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.ProjectLead = (MYCASService.encryptedlogin(this.Project.ProjectLead)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.Type = (MYCASService.encryptedlogin(this.Project.Type)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.UserId = (MYCASService.encryptedlogin(this.Project.UserId)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.WBSEelement = (MYCASService.encryptedlogin(this.Project.WBSEelement)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.PhoneNumber = (MYCASService.encryptedlogin(this.Project.PhoneNumber)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.AuthCode = (MYCASService.encryptedlogin(this.Project.AuthCode)).ciphertext.toString(CryptoJS.enc.Base64);
        // this.Project.GroupMembers = (MYCASService.encryptedlogin(this.Project.GroupMembers)).ciphertext.toString(CryptoJS.enc.Base64);
        this.Project.DeviceType = this.Device;
        this.Project.EnterpriseID = this.LoginEnterpriseID;
        this.Project.strType = "Project";

        this.capservice
          .InsertVoiceAdminDetails(this.Project)
          .subscribe((data) => {
            if (
              data.toString() ==
                "Please Enter valid Project Member or Project Lead or User EnterpriseID" ||
              data.toString() == "Please Enter valid WBS"
            ) {
              alert(data);
              //this.clear();
            } else {
              alert(data);
              this.clear();
            }
          });
      }
    }
  }
  EditProject(projectMemberAssignment) {
    this.successfulData.selected = Object.assign({}, projectMemberAssignment); //(projectMemberAssignment);//angular.copy(projectMemberAssignment);
  }
  DeleteProject(projectMemberAssignment) {
    this.capservice
      .DeleteVoiceAdminDetails(
        projectMemberAssignment.Id,
        "Project",
        this.LoginEnterpriseID,
        null
      )
      .subscribe((data) => {
        alert(data);
        this.clear();
      });
  }
  ProjectUpdate(projectMemberAssignment) {
    var message = '';

    if (this.Device == "Skype" || this.Device == "Teams") {
      if ($("#grdCountries").val() == "") {
        message = "Please Select Country";
      }
      if ($("#grdProjectName").val() == "") {
        message = message + "\n" + "Please Enter Project Name";
      }
      if ($("#grdProjectLead").val() == "") {
        message = message + "\n" + "Please Enter Project Lead";
      }
      if ($("#grdType").val() == "") {
        message = message + "\n" + "Please Select Type";
      }
      if ($("#grdProjectMembers").val() == "") {
        message = message + "\n" + "Please Enter Project Members";
      }
    } else {
      if ($("#grdECCountries").val() == "") {
        message = "Please Select Country";
      }
      if ($("#grdECProjectName").val() == "") {
        message = message + "\n" + "Please Enter Project Name";
      }
      if ($("#grdECProjectLead").val() == "") {
        message = message + "\n" + "Please Enter Project Lead";
      }
      if ($("#grdECType").val() == "") {
        message = message + "\n" + "Please Select Type";
      }
      if ($("#grdUserID").val() == "") {
        message = message + "\n" + "Please Enter User ID";
      }
      if ($("#grdWBSE").val() == "") {
        message = message + "\n" + "Please Enter WBSE";
      }
      if ($("#grdAuthCode").val() == "") {
        message = message + "\n" + "Please Enter AuthCode";
      }
      if ($("#grdPhoneNumber").val() == "") {
        message = message + "\n" + "Please Enter Phone Number";
      }
    }
    if (message != "") {
      alert(message);
    }
    else {
      var i = $('#grdProjectMembers').val(); var val = '';
      var keywordsArr = i.split(',')
      if (keywordsArr.length > 5) {
        alert("Only 5 or less Enterprise/Group Id's are allowed");
      } else {
        if (this.Device == "Skype") {
          val =
            $("#grdProjectMembers").val() + "," + $("#grdProjectLead").val();
        } else {
          val = $("#grdECProjectLead").val() + "," + $("#grdUserID").val();
        }

        //  this.successfulData.projectMemberAssignments[idx] = angular.copy(this.successfulData.selected);
        this.successfulData.selected.ID1 =
          this.successfulData.selected.Id.toString();
        this.successfulData.selected.Id = this.successfulData.selected.Id;

        //  this.successfulData.selected.Country = (MYCASService.encryptedlogin(this.successfulData.selected.Country)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.ProjectName = (MYCASService.encryptedlogin(this.successfulData.selected.ProjectName)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.ProjectLead = (MYCASService.encryptedlogin(this.successfulData.selected.ProjectLead)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.Type = (MYCASService.encryptedlogin(this.successfulData.selected.Type)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.UserId = (MYCASService.encryptedlogin(this.successfulData.selected.UserId)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.WBSEelement = (MYCASService.encryptedlogin(this.successfulData.selected.WBSEelement)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.PhoneNumber = (MYCASService.encryptedlogin(this.successfulData.selected.PhoneNumber)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.AuthCode = (MYCASService.encryptedlogin(this.successfulData.selected.AuthCode)).ciphertext.toString(CryptoJS.enc.Base64);
        //  this.successfulData.selected.GroupMembers = (MYCASService.encryptedlogin(this.successfulData.selected.GroupMembers)).ciphertext.toString(CryptoJS.enc.Base64);

        this.successfulData.selected.DeviceType = this.Device;
        this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
        this.successfulData.selected.strType = "Project";

        this.capservice
          .UpdateVoiceAdminDetails(this.successfulData.selected)
          .subscribe((data) => {
            if (
              data.toString() ==
                "Please Enter valid Project Member or Project Lead or User EnterpriseID" ||
              data.toString() == "Please Enter valid WBS"
            ) {
              alert(data);
              this.clear();
            } else {
              alert(data);
              this.clear();
            }
          });
      }
    }
  }
  reset() {
    this.successfulData.selected = {};
  }
  ClearDevice() {
    $("#grdfCountries").val("");
    $("#grdfProjectName").val("");
    $("#grdfProjectLead").val("");
    $("#grdfType").val("");
    $("#grdCCountries").val("");
    $("#grdCProjectName").val("");
    $("#grdCProjectLead").val("");
    $("#grdCType").val("");
    $("#grdECCountries").val("");
    $("#grdECProjectName").val("");
    $("#grdECProjectLead").val("");
    $("#grdECType").val("");
    $("#grdfProjectMembers").val("");
    $("#grdfUserID").val("");
    $("#grdfWBSE").val("");
    $("#grdfAuthCode").val("");
    $("#grdfPhoneNumber").val("");
    $("#grdCountries").val("");
    $("#grdProjectName").val("");
    $("#grdProjectLead").val("");
    $("#grdType").val("");
    $("#grdProjectMembers").val("");
    $("#grdUserID").val("");
    $("#grdWBSE").val("");
    $("#grdAuthCode").val("");
    $("#grdPhoneNumber").val("");
    $("#dlstProjectName").val("");
    $("#dlstCountry").val("");
  }
  clear() {
    $("#grdfCountries").val("");
    $("#grdfProjectName").val("");
    $("#grdfProjectLead").val("");
    $("#grdfType").val("");
    $("#grdCCountries").val("");
    $("#grdCProjectName").val("");
    $("#grdCProjectLead").val("");
    $("#grdCType").val("");
    $("#grdECCountries").val("");
    $("#grdECProjectName").val("");
    $("#grdECProjectLead").val("");
    $("#grdECType").val("");
    $("#grdfProjectMembers").val("");
    $("#grdfUserID").val("");
    $("#grdfWBSE").val("");
    $("#grdfAuthCode").val("");
    $("#grdfPhoneNumber").val("");
    $("#grdCountries").val("");
    $("#grdProjectName").val("");
    $("#grdProjectLead").val("");
    $("#grdType").val("");
    $("#grdProjectMembers").val("");
    $("#grdUserID").val("");
    $("#grdWBSE").val("");
    $("#grdAuthCode").val("");
    $("#grdPhoneNumber").val("");
    $("#dlstProjectName").val("");
    $("#dlstCountry").val("");
    //this.DeviceTypeEvent(null);
    $("#divProjectDetails").css("display", "block");
    this.LoadInitData();
    this.ClearDevice();
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);
    // get current page of items
    this.successfulData.projectMemberAssignments = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  setFile(event) {
    this.theFile = event.target.files[0];
  }
  addFileDetails() {
    this.dataLoader = true;
  var file = this.addModifyHostNamesForm.controls.inputFile.value;
    var ext = file.split('.').pop().toLowerCase();
    if (file == '') {
        alert('Please Upload The Template');
      this.dataLoader = false;
      return;
    }
    if (ext != "xls" && ext != "xlsx") {
      alert("Please upload only Excel file with .xls or .xlsx extension only");
      $("#fileControl").val("");
      this.dataLoader = false;
    }
    else {
        var formData = new FormData();
        formData.append('file', this.theFile);
        this.capservice.UploadHostTemplate(formData).subscribe(data => {
            this.addModifyHostNamesForm.controls.inputFile.setValue('');
        alert(data);
        this.LoadInitData();
        this.dataLoader = false;
      });
    }
  }
}
